import * as Yup from "yup";

import { cents } from "../../../../utils";
import { createForm } from "../../../forms";

import type { TypeSafeReactLocalization } from "../../../../composites";

export type SendViaTemplateFormFields = {
  fedwireTemplate?: API.FedwireTemplate;
  fedwireTemplateId?: API.FedwireTemplateId;
  amount?: Cents;
  memo?: string;
  wireReason?: string;
  wireReasonRequired?: boolean;
};

const translateValidationSchema = ({ getString }: TypeSafeReactLocalization) =>
  Yup.object().shape({
    fedwireTemplate: Yup.object()
      .nullable()
      .required(getString("form-generic-validation-required")),
    fedwireTemplateId: Yup.string().required(
      getString("form-generic-validation-required"),
    ),
    amount: Yup.number().when(
      "fedwireTemplate",
      ([fedwireTemplate]: Array<API.FedwireTemplate | undefined>, schema) => {
        if (!fedwireTemplate?.amount) {
          return Yup.number()
            .integer(getString("form-generic-validation-number"))
            .positive(getString("form-generic-validation-positive-number"))
            .required(getString("form-generic-validation-required"));
        }
        return schema;
      },
    ),
    memo: Yup.string().when(
      "fedwireTemplate",
      ([fedwireTemplate]: Array<API.FedwireTemplate | undefined>, schema) => {
        if (!fedwireTemplate?.memo) {
          return Yup.string()
            .min(1)
            .max(
              140,
              getString("form-generic-validation-limit-characters", {
                count: 140,
              }),
            )
            .required(getString("form-generic-validation-required"));
        }
        return schema;
      },
    ),
    wireReason: Yup.string().when(
      ["fedwireTemplate", "wireReasonRequired"],
      (values: any, schema) => {
        const [fedwireTemplate, wireReasonRequired] = values;
        if (wireReasonRequired && !fedwireTemplate?.wire_reason) {
          return Yup.string().required(
            getString("form-generic-validation-required"),
          );
        }
        return schema;
      },
    ),
  });

const initialValues: SendViaTemplateFormFields = {
  fedwireTemplateId: "" as API.FedwireTemplateId,
  fedwireTemplate: undefined,
  amount: cents(0),
  wireReason: "",
  wireReasonRequired: false,
  memo: "",
};

export const sendViaTemplateForm = createForm({
  initialValues,
  translateValidationSchema,
});
